export const formatRouteDate = (dateStr: string | null): string | null => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return null;
  return `${date.getMonth() + 1}/${date.getDate()}`;
};

export const formatTransportRouteInfo = (
  origin: string | null,
  destination: string | null,
  departureDate: string | null
): string => {
  const route = origin && destination ? `${origin} → ${destination}` : '';
  const date = formatRouteDate(departureDate);
  const dateStr = date ? `（${date}）` : '';
  return route || dateStr ? `：${route}${dateStr}` : '';
};

export const formatHotelLocationInfo = (
  destination: string | null,
  checkinDate: string | null,
  checkoutDate: string | null = null
): string => {
  const location = destination || '';
  const checkin = formatRouteDate(checkinDate);
  const checkout = formatRouteDate(checkoutDate);
  const periodStr = (() => {
    if (checkin && checkout) return `（宿泊期間：${checkin}〜${checkout}）`;
    if (checkin) return `（${checkin}）`;
    return '';
  })();
  return location || periodStr ? `：${location}${periodStr}` : '';
};
